
          import components from '/home/friedolin/git/friedolinfoerder/src/page-components'; 
          export default components;
        